import utils from '@src/common/utils'
import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '110px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '巡检点编号',
        prop: 'fireassetCode',
        // search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        rules: [
          { required: true, message: '请输入巡检点编号', trigger: 'blur' }
        ]
      },
      {
        label: '巡检点名称',
        prop: 'fireassetName',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        rules: [
          { required: true, message: '请输入巡检点名称', trigger: 'blur' }
        ]
      },
      {
        label: '管理人',
        prop: 'personnelNames',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        hide: true,
        span: 12,
        rules: [
          {
            required: true,
            message: '请选择管理人',
            trigger: ['change', 'blur']
          }
        ]
      },
      {
        label: '管理人部门',
        prop: 'departmentNames',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        hide: true,
        span: 12
      },
      // {
      //   label: '管理人部门',
      //   prop: 'personnelPart',
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   formslot: true,
      //   viewslot: true,
      //   hide: true,
      //   span: 12,
      //   rules: [{ required: true, message: '请选择管理人', trigger: 'blur' }],
      // },
      {
        label: '巡检类型',
        prop: 'fireassetType',
        type: 'select',
        search: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        formslot: true,
        align: 'center',
        span: 12,
        dicData: Dic.find('SENU105'),
        viewFormatter: (row, value) => {
          if (value) {
            return Dic.findByValue('SENU105', Number(value))
          }
          return ''
        },
        rules: [
          {
            required: true,
            message: '请选择巡检类型',
            trigger: ['change', 'blur']
          }
        ],
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU105', Number(value)) : ''
        }
      },
      {
        label: '资产信息',
        prop: 'fireassetDetail',
        span: 24,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        hide: true,
        formslot: true,
        viewslot: true,
        overHidden: true
        // rules: [{ required: true, message: '请输入资产名称', trigger: 'blur' }]
      },
      {
        label: '所在楼栋',
        prop: 'buildingName',
        search: true,
        searchSlot: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: 'center',
        placeholder: '请选择楼栋',
        rules: [{ required: true, message: '请选择楼栋', trigger: 'blur' }]
      },
      {
        label: '所属楼层',
        prop: 'floorName',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        span: 12,
        align: 'center',
        rules: [{ required: true, message: '请选择所属楼层', trigger: 'blur' }]
      },
      // {
      //   label: '型号',
      //   prop: 'fireassetVersion',
      //   type: 'select',
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   span: 12,
      //   overHidden: true,
      //   align: 'center',
      //   dicData: Dic.find('SENU107'),
      //   viewFormatter: (row, value) => {
      //     if (value) {
      //       return Dic.findByValue('SENU107', Number(value))
      //     }
      //     return ''
      //   },
      //   rules: [{ required: true, message: '请选择型号', trigger: 'blur' }],
      //   formatter: function(row, value) {
      //     return value ? Dic.findByValue('SENU107', Number(value)) : ''
      //   }
      // },
      // {
      //   label: '生产时间',
      //   prop: 'produceTime',
      //   type: 'date',
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   span: 12,
      //   align: 'center',
      //   formatter: function (row, value) {
      //     return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD') : '';
      //   }
      // },
      // {
      //   label: '检修时间',
      //   type: 'date',
      //   prop: 'fixTime',
      //   addDisplay: true,
      //   editDisplay: true,
      //   viewDisplay: true,
      //   span: 12,
      //   align: 'center',
      //   formatter: function (row, value) {
      //     return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD') : '';
      //   }
      // },

      {
        label: '巡检计划',
        prop: 'planCode',
        type: 'select',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        span: 12,
        rules: [{ required: true, message: '请选择巡检计划', trigger: 'blur' }]
      },
      {
        label: '巡检项',
        prop: 'patrolItemGroupCode',
        type: 'select',
        hide: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        formslot: true,
        viewslot: true,
        span: 12,
        rules: [{ required: true, message: '请选择巡检项', trigger: 'blur' }]
      },
      {
        label: '资产描述',
        prop: 'fireassetDesc',
        type: 'textarea',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        minRows: 3,
        span: 24,
        maxlength: 200,
        rules: [{ required: true, message: '请输入资产描述', trigger: 'blur' }]
      },
      {
        label: '设备二维码',
        prop: 'deviceQrCode',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12
      }
    ]
  }
}
export default tableOption
